import { Skeleton } from 'antd';
import React, { memo } from 'react';
import { fillArrayWithNumber } from 'utils/dataTypes/array';
import clsx from 'clsx';

type AnimatedSkeletonLoaderProps = {
  rows?: number;
  wrapperClassName?: string;
};

const AnimatedSkeletonLoader = ({
  rows = 5,
  wrapperClassName,
}: AnimatedSkeletonLoaderProps) => {
  return (
    <div className={clsx('flex flex-col gap-y-4 pb-4', wrapperClassName ?? '')}>
      {fillArrayWithNumber(rows).map(item => (
        <Skeleton active key={item} />
      ))}
    </div>
  );
};

export default memo(AnimatedSkeletonLoader);
